<template>
  <input class="w-full pl-5 border rounded-r leading-8 text-sm focus:outline-none 
           disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    :value="modelValue" :type="type" @input="updateModelValue($event)" :placeholder="placeholder"
    :autocomplete="resolvedAutocomplete" :maxlength="maxlength" :disabled="disabled" />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: String,
  type: { type: String, default: "text" },
  placeholder: String,
  maxlength: Number,
  autocomplete: String,
  autocpmlete: { type: String, default: "off" },
  disabled: { type: Boolean, default: false },
  sanitizer: Function,
});

const emits = defineEmits(["update:modelValue"]);
const resolvedAutocomplete = computed(
  () => props.autocomplete || props.autocpmlete || "off",
);

function updateModelValue(event) {
  const value = props.sanitizer
    ? props.sanitizer(event.target.value)
    : event.target.value;

  // 同步输入框显示值，避免输入法组合输入被过滤后仍残留在 DOM 中。
  if (event.target.value !== value) {
    event.target.value = value;
  }
  emits("update:modelValue", value);
}
</script>
